// @ts-nocheck
import React from 'react'
import styles from './CardTable.module.scss'

export const CardTableNoResults = ({ label }) => (
  <div className={styles.noResults}>{label}</div>
)
